export default __webpack_public_path__ + "static/scf-icon-d6ae80a3295f241a0b7456cd2f38ba01.png";